import { ButtonVariant } from "@/components/CustomLinkButton";

export const VERB_ID = 'http://adlnet.gov/expapi/verbs';

// Each of these represents a launched page, conversation is called 'Mimi' in a lot of documentation
export type LaunchedPageId = 'goal' | 'conversation' | 'feedback' | 'chatlog';

export type CheckResult = 'COMPLETE' | 'PARTIAL' | 'FAIL';

export type StudentOrTeacher = 'student' | 'teacher';

export type ReceivedResultType = 'USER_SILENT' | 'USER_CEFR_RESULT';

export type Control = 'readConversation' | 'continueConversation' | 'closeConversation';

export type ReceiveMessageType =
    'close' |
    'currentScreen' |
    'totalScreens' |
    'exitConversation' |
    Control;

export type SendMessageType =
    'init' |
    'ready' |
    'newStatements' |
    'fullScreen' |
    'showNextActivityBtn' |
    'terminated' |
    'controlsChange' |
    'iframeEvents' |
    'showExitConfirmationModal';

export type ReceiveMessageParams = { type: ReceiveMessageType, data?: string | {[key: string]: string} };
export type SendMessageParams = { type: SendMessageType, data?: string | {[key: string]: string} };

export type ReceiveHandler = (
    transaction: { complete: (message: unknown) => void, delayReturn: (shouldDelay: boolean) => void },
    data: unknown
) => void;
export type ReceiveHandlers = { [message in ReceiveMessageType]: ReceiveHandler; };

export type StatementOptions = { verbId?: string };
export type ControlOptions = { isVisible: boolean, isActive?: boolean, variant?: ButtonVariant }